import React from 'react'
import { Rating } from 'react-simple-star-rating'

interface StarRatingProps {
    ratingValue: number
    fillColor: string
    emptyColor: string
    starSize: number
}

export const StarRating = ({
    ratingValue,
    fillColor,
    emptyColor,
    starSize,
}: StarRatingProps) => {
    return (
        <Rating
            ratingValue={ratingValue}
            fillColor={fillColor}
            emptyColor={emptyColor}
            size={starSize}
            readonly
        />
    )
}

export default StarRating
